import { render } from "./Update.vue?vue&type=template&id=545cecba&ts=true"
import script from "./Update.vue?vue&type=script&lang=ts"
export * from "./Update.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\dev\\laragon\\www\\test-interactiv\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__